/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type LinkRowItem_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LinkRow_viewer$ref: FragmentReference;
export type LinkRow_viewer = {|
  +$fragmentRefs: LinkRowItem_viewer$ref,
  +$refType: LinkRow_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "LinkRow_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "LinkRowItem_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cecf1b6bac7b33f5c508d6f050403951';
module.exports = node;
